import moment from "moment";
import React from "react";
import ResponsivePagination from "react-responsive-pagination";
import CONSTANT from "../../../constant";
import { getFileCreationReport } from "../../../actions/FileAction";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      page: 1,
      list: undefined,
      total: 0,
      totalFiles: 0,
      showLoader: false,
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.adminSection;
    this.loadReport(this.state.page);
  }

  render() {
    const { list, totalFiles, showLoader, startDate, endDate } = this.state;
    return (
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">File Creation Report</h1>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-3">
                  <label className="font-semibold">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => this.setState({ startDate: e.target.value })}
                  />
                </div>
                <div className="col-md-3">
                  <label className="font-semibold">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => this.setState({ endDate: e.target.value })}
                  />
                </div>
                <div className="col-md-3 d-flex align-items-end">
                  <button
                    className="btn btn-primary"
                    onClick={this.handleSearch}
                    disabled={showLoader}
                  >
                    {showLoader ? "Loading..." : "Search"}
                  </button>
                </div>
              </div>

              {list !== undefined && (
                <div className="row mt-3">
                  <div className="col-md-4">
                    <div className="card p-3 bg-light">
                      <h5 className="mb-0">
                        Total Files Created: <strong>{totalFiles}</strong>
                      </h5>
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <table className="tablen">
                          <thead>
                            <tr>
                              <th scope="col" className="text-nowrap">S.No.</th>
                              <th scope="col" className="text-nowrap">Employee Name</th>
                              <th scope="col" className="text-nowrap">Employee No.</th>
                              <th scope="col" className="text-nowrap">Designation</th>
                              <th scope="col" className="text-nowrap">Department</th>
                              <th scope="col" className="text-nowrap">Files Created</th>
                            </tr>
                          </thead>
                          <tbody>
                            {list === undefined && (
                              <tr>
                                <td colSpan={6} className="text-center">Loading...</td>
                              </tr>
                            )}
                            {list !== undefined && list.length === 0 && (
                              <tr>
                                <td colSpan={6} className="text-center">No records found</td>
                              </tr>
                            )}
                            {list !== undefined &&
                              list.map((item: any, index: number) => {
                                const { page } = this.state;
                                return (
                                  <tr key={index}>
                                    <td>{(page - 1) * 10 + index + 1}</td>{/* S.No. continues across pages */}
                                    <td>{item.employeeName}</td>
                                    <td>{item.employeeNumber}</td>
                                    <td>{item.designation}</td>
                                    <td>{item.department}</td>
                                    <td>{item.filesCreated}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="mt-4 p-4">
                      {list !== undefined && list.length !== 0 && (
                        <ResponsivePagination
                          activeItemClassName="Pagi-number-ac"
                          current={this.state.page}
                          maxWidth={1}
                          total={Math.ceil(this.state.total / 10)}
                          onPageChange={this.handlePageChange}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

  // Search button click — reset to page 1
  handleSearch = () => {
    this.setState({ page: 1 }, () => {
      this.loadReport(1);
    });
  };

  // Pagination page change
  handlePageChange = (newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.loadReport(newPage);
    });
  };

  loadReport = (page: number) => {
    const { startDate, endDate } = this.state;
    this.setState({ showLoader: true, list: undefined });
    getFileCreationReport(startDate, endDate, page).then((res: any) => {
      this.setState({
        list: res?.result?.userWiseData || [],
        totalFiles: res?.result?.totalFiles || 0,
        total: res?.result?.total || 0, // <-- used for pagination
        showLoader: false,
      });
    });
  };
}

export default ComponentName;